import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { JOB_API } from "./apiRoutes";

interface UseGetJobPostingListProps {
  data: any; // contains limit, orderBy, search, etc.
  applicableCompany?: string; // NEW
  queryParams?: Omit<UseQueryOptions, "queryKey" | "queryFn">;
}

const getJobPostingList = async (payload: any) =>
  axiosAuth.post(`${JOB_API}/list`, payload);

const useGetJobPostingList = ({
  data,
  applicableCompany,
  queryParams,
}: UseGetJobPostingListProps): UseQueryResult<any> => {
  
  // 🔥 Ensure `search` object exists & inject applicableCompany
  const finalPayload = {
    ...data,
    search: {
      ...(data?.search || {}),
      ...(applicableCompany && { applicableCompany }),
    },
  };

  return useQuery({
    queryKey: ["job-posting", finalPayload], // depends on filters + company
    queryFn: () => getJobPostingList(finalPayload),
    select: (response: any) => response.data,
    enabled: !!finalPayload.search.applicableCompany, // prevent API call if missing
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetJobPostingList;
